// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Components/PdfSettings/PDFPrintSettings";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.emailPdfButton = {
    sizeVariant: "small",
    css: css`
        padding: 0 12px;

        &&&&& ${IconWrapper} {
            top: 2px;
        }

        &&& svg {
            color: ${getColor("text")};
            transition: all 200ms ease-in-out;
        }

        @media (max-width: 481px) {
            width: 100%;
            margin: 0;
        }
    `,
    icon: {
        src: "Mail",
        position: "left",
    },
};

styles.savePdfButton = {
    sizeVariant: "small",
    variant: "secondary",
    css: css`
        padding: 0 12px;

        &&&&& ${IconWrapper} {
            top: 2px;
        }

        &&& svg {
            color: ${getColor("text")};
            transition: all 200ms ease-in-out;
        }

        @media (max-width: 481px) {
            width: 100%;
            margin: 0;
            margin-bottom: 15px;
        }
    `,
    icon: {
        src: "SavePdf",
        position: "left",
    },
};

styles.bottomSectionWrapper = {
    width: 12,
    css: css`
        justify-content: flex-end;
        position: relative;
        margin-top: 10px !important;
        gap: 40px;
        &:before {
            content: " ";
            position: absolute;
            top: 0;
            width: calc(100% + 40px);
            left: -20px;
            height: 1px;
            background: ${getColor("common.ui2")};
        }
        @media (max-width: 480px) {
            flex-wrap: wrap;
        }
    `,
};